<template>
  <div>
    <h1 v-t="'entities.status.name_plural'" class="mt-0"></h1>

    <dx-data-grid
      ref="dataGrid"
      :columns="columns"
      :data-source="store"
      :remote-operations="remoteOperations"
      :show-borders="true"
      :show-row-lines="false"
      :show-column-lines="true"
      :row-alternation-enabled="true"
    >
      <dx-editing
        :allow-adding="true"
        :allow-updating="true"
        :allow-deleting="true"
        mode="row"
      />

      <dx-paging :page-size="15"/>
      <dx-pager
        :allowed-page-sizes="[15, 30, 50]"
        :visible="true"
        :show-info="true"
        :show-navigation-buttons="true"
        :show-page-size-selector="true"
      />
    </dx-data-grid>
  </div>
</template>

<script>
import { DxDataGrid } from 'devextreme-vue';
import { DxEditing, DxPager, DxPaging } from 'devextreme-vue/data-grid';
import createBackendStore from '@/lib/create-backend-store';
import { buildColumns } from '@/lib/data-grid-columns';

export default {
  name: 'Statuses',
  components: {
    DxDataGrid,
    DxEditing,
    DxPager,
    DxPaging,
  },
  data() {
    return {
      store: null,
      columns: this.buildColumns('status', [
        {
          property: 'name',
        },
        {
          property: 'station',
        },
        {
          property: 'restricted',
        },
        {
          property: 'position',
          sortOrder: 'asc',
          width: 80,
        },
      ]),
      remoteOperations: {
        paging: true,
        filtering: true,
        sorting: true,
      },
    };
  },
  methods: {
    buildColumns,
    configureStore(columns) {
      const fields = columns
        .map(c => c.dataField)
        .filter(f => f);

      return createBackendStore('/statuses', { fields });
    },
  },
  created() {
    this.store = this.configureStore(this.columns);
  },
};
</script>

<style scoped>

</style>
